/**
 * 租车筛选条件状态管理（品牌、车型分类）
 */
import { create } from "zustand";
import { fetchBrandList, fetchCarTypeList, type BrandItem, type CarTypeItem } from "@/api/car";

interface CarFilterState {
  brands: BrandItem[];
  categories: CarTypeItem[];
  isLoading: boolean;
  hasLoaded: boolean;
  
  loadFilters: () => Promise<void>;
}

export const useCarFilterStore = create<CarFilterState>((set, get) => ({
  brands: [],
  categories: [],
  isLoading: false,
  hasLoaded: false,

  loadFilters: async () => {
    // 如果已经加载过，不再重复加载
    if (get().hasLoaded || get().isLoading) return;
    
    set({ isLoading: true });
    try {
      const [brandData, typeData] = await Promise.all([
        fetchBrandList(),
        fetchCarTypeList(),
      ]);
      set({ 
        brands: brandData, 
        categories: typeData,
        hasLoaded: true,
        isLoading: false 
      });
    } catch (error) {
      console.error("加载筛选条件失败:", error);
      set({ hasLoaded: true, isLoading: false });
    }
  },
}));
